<template>
    <div>
        <el-row>
            <el-col :lg="10" :offset="2">
               禮卷發行單位:
                    <el-tag type="info" effect="dark">{{this.couponDetail.type == 1 ? '公司': '通路商'}}</el-tag>
                    
              
            </el-col>
            <el-col :lg="10">
                禮卷品牌:  <el-tag type="info" effect="dark">{{this.couponDetail.brand_id == 1 ? 'N牌': 'S牌'}}</el-tag>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                禮卷名稱: <el-tag type="info" effect="dark">{{this.couponDetail.name}}</el-tag>
            </el-col>
            <el-col :lg="10">
                使用期限: <el-tag type="info" effect="dark">{{this.couponDetail.on_sale_start}}</el-tag>
                 -  <el-tag type="info" effect="dark">{{this.couponDetail.on_sale_end}}</el-tag>
                 
            </el-col>
        </el-row>
         <el-row>
            <el-col :lg="10" :offset="2" v-if="isType">
                    <el-tag  color="#f9c6ba" effect="dark" style="color:red; border-color:red;">{{this.level0}}</el-tag>
                
            </el-col>
            <el-col :lg="10" v-if="isType">
                折扣金:  <el-tag type="info" effect="dark">{{this.couponDetail.memberdiscount_0}}</el-tag>
                
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                    <el-tag  color="#f9c6ba" effect="dark" style="color:red; border-color:red;">{{this.level1}}</el-tag>
                
            </el-col>
            <el-col :lg="10">
                折扣金:  <el-tag type="info" effect="dark">{{this.couponDetail.memberdiscount_1}}</el-tag>
                
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-tag  color="#f9c6ba" effect="dark" style="color:#494ca2;border-color:#f9c6ba;font-wi">{{this.level2}}</el-tag>
            </el-col>
            <el-col :lg="10">
                折扣金:  <el-tag type="info" effect="dark">{{this.couponDetail.memberdiscount_2}}</el-tag>
                
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2"></el-col>
            <el-col :lg="10"></el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-button type="primary" @click="editTabs">編輯</el-button>
                <el-button type="default" @click="back">返回</el-button>
            </el-col>
            <el-col :lg="10"></el-col>
        </el-row>
        
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'Detail',
        props: {
            couponKey: String
        },
        data() {
            return {
                couponDetail: [],
                level0: '',
                level1: '',
                level2: '',
                isType: false
            }
        },
        computed: mapGetters(["getCouponDetail"]),
        methods: {
            ...mapActions(["fetchCouponDetail"]),
            async fetchDetail(){
                const data = {_key: this.couponKey}
                await this.$store.dispatch('fetchCouponDetail', data)
                this.couponDetail = this.getCouponDetail
                this.checkInput(this.couponDetail.brand_id)
                this.checkType(this.couponDetail.type)
            },
            editTabs(){
                this.$emit('editTabs', this.couponKey)
            },
            back(){
                this.$emit('back')
            },
             checkInput(brandId){
               if(brandId == 1){
                  
                   this.level1 = '白金'
                   this.level2 = '尊爵'
               }else if(brandId == 2){
                   this.level1 = '芙蓉'
                   this.level2 = '金鑽'
               }
           },
           checkType(type){
               if (type == 2) {
                    this.level0 = '非會員'
                    this.isType = true
               }else {
                   this.level10 = '',
                   this.isType = false
               }
           },
        },
        created() {
            this.fetchDetail()
          
        },
    }
</script>

<style lang="scss" scoped>
    .el-row {
        margin-bottom: 30px;
        font-weight: bold;
       
          font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    }
    .el-tag {
         font-weight: bold;
        font-size: 18px;
          font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    }
</style>